import './helpers.js';
import '../public/inc/bootstrap.min.js';
import '../public/inc/splide.min.js';
import App from './App.svelte';

let search = new Proxy(new URLSearchParams(window.location.search), {
        get: (searchParams, prop) => searchParams.get(prop),
    }),
    options = {};

if (search.params) {
    options = JSON.parse(decodeURIComponent(escape(atob(search.params))));
}

const app = new App({
    target: document.body,
    props: {options}
});

export default app;
